import { render, staticRenderFns } from "./MenuPreviewSection.vue?vue&type=template&id=0aaba45c&"
import script from "./MenuPreviewSection.vue?vue&type=script&lang=js&"
export * from "./MenuPreviewSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports